module.exports = __webpack_public_path__ + "static/ibm-plex-serif-v8-latin-500-edd6220e849cf2247f3fa9d46609da48.woff2";